<mat-tab-group>
  <mat-tab [label]="'Live assistance' | translate">

    <!-- Live assistance -->
    <div class="live-assistance">

      <div class="lista">

        <ng-container *ngIf="liveMaintenances$ | async as maintenances; else loading">

          <!-- Live assistance -->
          <app-assistance-request
            *ngFor="let maintenance of maintenances"
            [isLoading]="maintenance.id == isOpeningMaintenanceId"
            [serial]="maintenance.equipment.serialNumber"
            [equipmentName]="maintenance.equipment.model.name"
            [name]="maintenance.reason"
            [requesterName]="maintenance.fieldWorker.name"
            [date]="getDate(maintenance.scheduledAt)"
            [status]="maintenanceManager.getStatus(maintenance.status)"
            [operatorId]="maintenance.remoteExpert?.id"
            [isSelected]="selectedMaintenanceId == maintenance.id"
            (click)="startSupportMaintenanceRequest(maintenance)"
            (close)="selectedMaintenanceId = null"
          ></app-assistance-request>

          <!-- No live maintenances -->
          <div *ngIf="maintenances.length == 0" class="no-requests">
            {{ 'No maintenance requests found' | translate }}
          </div>

        </ng-container>

        <ng-container *ngIf="maintenancesAssignedToMe$ | async as maintenances">

          <!-- Assigned to me assistances -->
          <div *ngIf="maintenances.length > 0" class="assigned-label">
            {{ 'Assigned to me' | translate }}
          </div>
          <app-assistance-request
            *ngFor="let maintenance of maintenances"
            [isLoading]="maintenance.id == isOpeningMaintenanceId"
            [serial]="maintenance.equipment.serialNumber"
            [equipmentName]="maintenance.equipment.model.name"
            [name]="maintenance.reason"
            [requesterName]="maintenance.fieldWorker.name"
            [date]="getDate(maintenance.scheduledAt)"
            [status]="maintenanceManager.getStatus(maintenance.status)"
            [operatorId]="maintenance.remoteExpert?.id"
            [isSelected]="selectedMaintenanceId == maintenance.id"
            (click)="startSupportMaintenanceRequest(maintenance)"
            (close)="selectedMaintenanceId = null"
          ></app-assistance-request>

        </ng-container>

      </div>

      <div class="container">
        <app-assistance-view
          *ngIf="selectedMaintenanceId"
          [assistance]="getCurrentMaintenance()"
          [assistanceType]="AssistanceType.LIVE_MAINTENANCE"
          [canEditScene]="true"
          [canClose]="true"
          [canRecord]="true"
          (onClosing)="onMaintenanceClosing()"
          (onClosed)="onMaintenanceClosed()"
        ></app-assistance-view>

        <div *ngIf="!selectedMaintenanceId" class="no-assist">
          <img src="assets/img/no-chat.png" alt="no chat">
          <p>{{ 'Select a maintenance request to start' | translate }}</p>
        </div>
      </div>

    </div>

  </mat-tab>

  <!-- Maintenance history -->
  <mat-tab [label]="'Maintenance history' | translate">

    <ng-container *ngIf="maintenancesHistory">
      <app-table
        [columns]="getMaintenanceTableColumns()"
        [rows]="getMaintenanceTableData()"
        [paginator]="maintenancesPaginator"
        (onItemClicked)="showMaintenance($event, false)"
      ></app-table>
    </ng-container>

  </mat-tab>

  <!-- Planned maintenance from me -->
  <mat-tab *ngIf="environment.features.fieldManagerManagement && accountManager.isTeamLeaderOrAdmin()" [label]="'Planned maintenances' | translate">

    <ng-container *ngIf="plannedMaintenances">
      <app-table
        [columns]="getPlannedMaintenanceTableColumns()"
        [rows]="getPlannedMaintenanceTableData()"
        [paginator]="plannedMaintenancesPaginator"
        (onItemClicked)="showMaintenance($event, true)"
      ></app-table>
    </ng-container>

  </mat-tab>


</mat-tab-group>

<ng-template #loading>
  <app-scotty-spinner [diameter]="20" text="Loading"></app-scotty-spinner>
</ng-template>
